export interface ComparisonRow {
  without: string
  with: string
}
export const comparisonRows: ComparisonRow[] = [
  {
    without: 'Ponad 3 godziny tygodniowo na planowanie lekcji od zera',
    with: '5 minut: otwierasz plan i tydzień jest gotowy',
  },
  {
    without: 'Tabulatury z internetu, które nigdy nie pasują do poziomu ucznia',
    with: 'Ćwiczenia ułożone według poziomu, gotowe do druku',
  },
  {
    without: 'Sześciu uczniów, sześć poziomów, zero planu',
    with: 'Jasna ścieżka dla każdego ucznia, od tygodnia 1 do tygodnia 16',
  },
  {
    without: 'Rodzice pytają: „Gdzie są efekty?”',
    with: 'Gotowe arkusze ocen z mierzalnymi postępami',
  },
  {
    without: 'Uczniowie, którzy nie wracają w kolejnym semestrze',
    with: 'Uczniowie, którzy chcą kontynuować',
  },
]
export const problems: string[] = [
  'Twoje wieczory i weekendy znikają na przygotowywaniu lekcji.',
  'Uczniowie w kółko powtarzają te same ćwiczenia i zaczynają się nudzić.',
  'Początkujący, średniozaawansowani, zaawansowani: nie da się ogarnąć wszystkich naraz.',
  'Rodzice pytają: „Gdzie są efekty?”, a Ty nie masz czego im pokazać.',
  'Każdy semestr zaczynasz od zera.',
]
